var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"img-fluid mx-auto mt-8 d-block",attrs:{"src":"https://app-works.app/image/cache/original/files/images/transcript-logo.png","width":"250"}})])
}]

export { render, staticRenderFns }